import Clinrecs from './Clinrecs'
export default Clinrecs
